<template lang="pug">
  v-card(flat)
    v-card-text
      v-text-field(
        v-model="payment"
        type="number"
        rounded
        label="Введите сумму поступления"
        filled
      )
    v-card-actions
      v-btn.ml-auto(
        :loading="contract.paymentLoading"
        color="success"
        @click="contract.setPayment(Number(payment*100))"
      ) Сохранить
</template>
<script>
export default {
  props: {
    contract: { type: Object, required: true },
  },
  data() {
    return {
      payment: null,
    };
  },
};
</script>
